// extracted by mini-css-extract-plugin
export default {"container":"Mogc7c"};